import React, { FC, useEffect, useState } from "react";
import Styles from "components/chatSideBar/ChatSideBar.module.scss";
import ChatParticipants from "./chatParticipants/ChatParticipants";
import { getCurrentDate, getDistance, normalizeDistance } from "helpers/utils";
import { updateNewRoomStatus, updateLastSeenMessage } from "store/services/firebase-broadcast";
import { RoomStatus } from "modules/types/types";
import moment from "moment";

interface ChatSideBarProps {
  cssClass?: string;
  conversations: any;
  setSelected: Function;
  activateRoom?: any;
  setActiveRoom?: any;
  callBack?: any;
  selected?: any;
}

const user = JSON.parse(localStorage.getItem("user") as string);
const ChatSideBar: FC<ChatSideBarProps> = (props: ChatSideBarProps) => {
  const { cssClass, conversations, setSelected, activateRoom, setActiveRoom, callBack, selected } = props;
  const [selectedChat, setSelectedChat] = useState(-1);
  
  const handleChangeChat = (i: any) => {
    if (!i || !i.pk) {
      console.warn('Invalid item passed to handleChangeChat:', i);
      return;
    }
    
    callBack(i)
    setSelectedChat(i.pk);
    setSelected(i);
    
    // Update room status
    // let updateRoom = {
    //   room:i,
    //   activeRoom: moment().format()
    // };
    // updateNewRoomStatus(updateRoom)
    
    // Update lastSeenMessage to mark messages as read
    updateLastSeenMessage(i.pk, user.pk);
  };

  useEffect(() => {
    if (selected && selected.pk) {
      setSelectedChat(selected.pk);
    }
  }, [selected])

  let conversationVideo = conversations?.length > 0 ? conversations.filter((r: any) => r.status === 'VIDEO') : []

  const sortRooms = (rooms: any) => rooms.sort((a: any, b: any) => {
    // Priority 1: Rooms hosted by the user
    const isHostA = a.host?.pk === user?.pk;
    const isHostB = b.host?.pk === user?.pk;
    
    if (isHostA && !isHostB) return -1;
    if (!isHostA && isHostB) return 1;
    
    // Priority 2: Rooms where user is a member
    const isMemberA = a.participants?.some((p: any) => p.pk === user?.pk);
    const isMemberB = b.participants?.some((p: any) => p.pk === user?.pk);
    
    if (isMemberA && !isMemberB) return -1;
    if (!isMemberA && isMemberB) return 1;
    
    // Priority 3: Sort by distance, handle rooms without location
    const distanceA = normalizeDistance(a.distance);
    const distanceB = normalizeDistance(b.distance);
    
    if (distanceA !== distanceB) {
      return distanceA - distanceB;
    }
    
    // Priority 4: If distances are equal (or both invalid), sort by creation time
    return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
  });

  const videoRooms = conversations?.length > 0 ?
    sortRooms(conversations.filter((r: any) => r.host && r.status === 'VIDEO' && r.is_deleted !== true))
    : [];

  const chatRooms = conversations?.length > 0 ?
    sortRooms(conversations.filter((r: any) => r.host && r.status !== 'VIDEO' && r.is_deleted !== true))
    : [];
    
  return (
    <aside>
      <div className={Styles.nearbyRooms}>
        <h6 className="m-0 font-weight-600">Nearby Rooms</h6>
      </div>
      <div className={Styles.nearbyRoomsListing}>
        <p
          className={`${Styles.status} ${cssClass} ${Styles.success} text-uppercase mb-0`}
        >
          Streaming
        </p>
        <ul className={`${Styles.activeListing} customScrollBar list-unstyled`}>
          {/* Video conversations */}
          {videoRooms.map((i: any, index: number) => (
              <ChatParticipants
                item={i}
                key={i.pk || index}
                handleChangeIndex={handleChangeChat}
                itemIndex={i.pk === selectedChat}
                isSuperHost={i.host?.is_super_host}
                id={i.pk}
                activateRoom={activateRoom}
                setActiveRoom={setActiveRoom}
                callBack={callBack}
                selected={selected}
              />
            )
          )}
        </ul>
        <p className={`${Styles.notActive} ${Styles.status} text-uppercase mb-0`}>Chat</p>
        <ul className={`${
            conversationVideo?.length < 1
              ? Styles.offlineListingFull
              : conversationVideo?.length === 1
              ? Styles.offlineListingOne
              : conversationVideo?.length === 2
              ? Styles.offlineListingTwo
              : conversationVideo?.length === 3
              ? Styles.offlineListingThree
              : Styles.offlineListing
          }  customScrollBar list-unstyled mb-0`}>
          {/* Chat conversations */}
          {chatRooms.map((i: any, index: number) => (
            <ChatParticipants
              item={i}
              key={i.pk || index}
              handleChangeIndex={handleChangeChat}
              itemIndex={i.pk === selectedChat}
              isSuperHost={i.host?.is_super_host}
              id={i.pk}
              offLineImageCss
              selected={selected}
            />
          )
        )}
        </ul>
      </div>
    </aside>
  );
};
export default ChatSideBar;
